export const ensureVendorScript = (
  src: string,
  onLoad?: () => void,
  onError?: () => void,
): void => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script = document.createElement('script');

  script.async = true;
  script.src = src;

  if (onLoad) {
    script.addEventListener('load', onLoad);
  }

  if (onError) {
    script.addEventListener('error', onError);
  }

  document.head.appendChild(script);
};
